/* LPJ Sports — aviso quando algo vai para o carrinho.
   Funciona com todos os botões do tema (lista de tamanhos no produto, quantidades nas coleções, gaveta do carrinho):
   quando o carrinho muda, mostra um aviso com o artigo, o total e a forma de entrega
   (abaixo de 200 €: levantamento na Loja Play Padel Madeira; a partir de 200 €: entrega grátis ao domicílio em todo o país),
   faz «saltar» o ícone do carrinho e mostra um botão flutuante do carrinho com o número de artigos. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('lpj-carrinho-config');
  var cfg = {};
  try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { cfg = {}; }
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fetchOriginal = window.fetch;
  var anterior = null;
  var tempo = null;
  var fechoAuto = null;
  var aviso = null;
  var botao = null;

  function dinheiro(c) {
    try { return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: cfg.moeda || 'EUR' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function dinheiroCurto(c) { return c % 100 === 0 ? (c / 100) + ' €' : dinheiro(c); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function mudaCarrinho(url) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url); }
  function naPaginaCarrinho() { return /\/cart\/?$/.test(window.location.pathname); }
  function gavetaAberta() { return !!document.querySelector('cart-drawer.active'); }

  /* Observa os pedidos do tema ao carrinho (o pedido segue igual; só se espreita se correu bem) */
  if (typeof fetchOriginal === 'function') {
    window.fetch = function () {
      var args = arguments;
      var pedido = fetchOriginal.apply(window, args);
      try {
        var entrada = args[0];
        var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) ? entrada.url : String(entrada || '');
        if (mudaCarrinho(url)) {
          pedido.then(function (r) { if (r && r.ok) agendar(); }).catch(function () {});
        }
      } catch (e) { /* nada */ }
      return pedido;
    };
  }

  function lerCarrinho() {
    return fetchOriginal.call(window, raiz + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function retrato(c) {
    var linhas = {};
    (c.items || []).forEach(function (i) { linhas[i.key] = i.quantity; });
    return { n: c.item_count, linhas: linhas };
  }
  function agendar() { clearTimeout(tempo); tempo = setTimeout(atualizar, 450); }

  function atualizar() {
    lerCarrinho().then(function (c) {
      var antes = anterior;
      anterior = retrato(c);
      var aumentou = !!antes && c.item_count > antes.n;
      atualizarBotao(c.item_count, aumentou);
      refrescarSeccoes();
      if (!aumentou) return;
      var item = null;
      var mais = 0;
      (c.items || []).forEach(function (i) {
        var d = i.quantity - (antes.linhas[i.key] || 0);
        if (d > mais) { mais = d; item = i; }
      });
      mostrarAviso(c, item, mais);
    }).catch(function () {});
  }

  /* Atualiza o número no ícone do cabeçalho e o conteúdo da gaveta do carrinho */
  function refrescarSeccoes() {
    var gaveta = document.querySelector('cart-drawer');
    var ids = ['cart-icon-bubble'];
    if (gaveta) ids.push('cart-drawer');
    return fetchOriginal.call(window, raiz + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var bolha = document.getElementById('cart-icon-bubble');
        if (bolha && s['cart-icon-bubble']) {
          var d1 = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
          var sec = d1.querySelector('.shopify-section');
          if (sec) bolha.innerHTML = sec.innerHTML;
        }
        if (gaveta && s['cart-drawer'] && !gaveta.classList.contains('active')) {
          var d2 = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
          var novo = d2.querySelector('#CartDrawer');
          var atual = document.getElementById('CartDrawer');
          if (novo && atual) atual.innerHTML = novo.innerHTML;
          var novaGaveta = d2.querySelector('cart-drawer');
          if (novaGaveta) gaveta.classList.toggle('is-empty', novaGaveta.classList.contains('is-empty'));
        }
      })
      .catch(function () {});
  }

  function abrirCarrinho(ev) {
    var gaveta = document.querySelector('cart-drawer');
    esconderAviso();
    if (!gaveta || typeof gaveta.open !== 'function') { window.location.href = raiz + 'cart'; return; }
    var origem = ev && ev.currentTarget;
    refrescarSeccoes().then(function () { gaveta.open(origem); });
  }

  function mostrarAviso(c, item, mais) {
    if (gavetaAberta() || naPaginaCarrinho()) return;
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'lpj-toast';
      aviso.setAttribute('role', 'status');
      aviso.setAttribute('aria-live', 'polite');
      aviso.hidden = true;
      document.body.appendChild(aviso);
      aviso.addEventListener('mouseenter', function () { clearTimeout(fechoAuto); });
      aviso.addEventListener('mouseleave', function () { clearTimeout(fechoAuto); fechoAuto = setTimeout(esconderAviso, 3500); });
    }
    var html = '<div class=lpj-toast__topo><span class=lpj-toast__ok aria-hidden=true>&#10003;</span><strong>' + esc(cfg.texto_adicionado || 'Adicionado ao carrinho') + '</strong><button type=button class=lpj-toast__fechar aria-label=Fechar>&times;</button></div>';
    if (item) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      html += '<a class=lpj-toast__item href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width=64 height=64>' : '<span></span>') +
        '<span><span class=lpj-toast__titulo>' + esc(item.product_title) + '</span>' +
        (item.variant_title ? '<span class=lpj-toast__var>' + esc(item.variant_title) + '</span>' : '') +
        '<span class=lpj-toast__var>Quantidade: ' + item.quantity + (mais > 0 && mais < item.quantity ? ' (+' + mais + ')' : '') + ' &middot; ' + dinheiro(item.final_line_price) + '</span></span></a>';
    }
    html += '<p class=lpj-toast__total>' + c.item_count + (c.item_count === 1 ? ' artigo' : ' artigos') + ' no carrinho &middot; <strong>' + dinheiro(c.total_price) + '</strong></p>';
    var minimo = Number(cfg.minimo_portes || 0);
    if (minimo > 0) {
      if (c.total_price >= minimo) {
        html += '<p class="lpj-toast__portes lpj-toast__portes--ok">&#10003; ' + esc(cfg.texto_portes_ok || 'Entrega grátis ao domicílio em todo o país, ilhas incluídas.') + '</p>';
      } else {
        var pct = Math.min(100, Math.round(c.total_price / minimo * 100));
        html += '<p class=lpj-toast__portes><strong>Abaixo de ' + dinheiroCurto(minimo) + ':</strong> ' + esc(cfg.texto_levantamento || 'levantamento na Loja Play Padel Madeira.') +
          ' Faltam <strong>' + dinheiro(minimo - c.total_price) + '</strong> para a entrega grátis ao domicílio em todo o país.</p><div class=lpj-toast__barra><span style="width:' + pct + '%"></span></div>';
      }
    }
    html += '<div class=lpj-toast__acoes><button type=button class="lpj-botao lpj-botao--contorno" data-lpj-ver>Ver carrinho</button><a class=lpj-botao href="' + raiz + 'checkout">Finalizar compra</a></div>';
    aviso.innerHTML = html;
    aviso.querySelector('.lpj-toast__fechar').addEventListener('click', esconderAviso);
    aviso.querySelector('[data-lpj-ver]').addEventListener('click', abrirCarrinho);
    aviso.hidden = false;
    window.requestAnimationFrame(function () { aviso.classList.add('lpj-toast--visivel'); });
    clearTimeout(fechoAuto);
    fechoAuto = setTimeout(esconderAviso, 7000);
  }

  function esconderAviso() {
    if (!aviso) return;
    clearTimeout(fechoAuto);
    aviso.classList.remove('lpj-toast--visivel');
    setTimeout(function () { if (!aviso.classList.contains('lpj-toast--visivel')) aviso.hidden = true; }, 300);
  }

  /* Botão flutuante do carrinho (aparece quando há artigos) */
  function atualizarBotao(n, saltar) {
    if (naPaginaCarrinho()) return;
    if (!botao) {
      botao = document.createElement('button');
      botao.type = 'button';
      botao.className = 'lpj-cesto';
      botao.innerHTML = '<svg width=24 height=24 viewBox="0 0 24 24" fill=none stroke=currentColor stroke-width=1.8 stroke-linecap=round stroke-linejoin=round aria-hidden=true focusable=false><path d="M5 8h14l-1 12.2a1 1 0 0 1-1 .8H7a1 1 0 0 1-1-.8L5 8z"/><path d="M9 10V7a3 3 0 0 1 6 0v3"/></svg><span class=lpj-cesto__n></span>';
      botao.addEventListener('click', abrirCarrinho);
      document.body.appendChild(botao);
    }
    botao.hidden = !n;
    botao.querySelector('.lpj-cesto__n').textContent = n > 99 ? '99+' : String(n);
    botao.setAttribute('aria-label', 'Ver carrinho (' + n + (n === 1 ? ' artigo)' : ' artigos)'));
    if (saltar) {
      [botao, document.getElementById('cart-icon-bubble')].forEach(function (el) {
        if (!el) return;
        el.classList.remove('lpj-salto');
        void el.offsetWidth;
        el.classList.add('lpj-salto');
      });
    }
  }

  function iniciar() {
    lerCarrinho().then(function (c) {
      if (!anterior) anterior = retrato(c);
      atualizarBotao(c.item_count, false);
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
